import '../../scripts/common';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import CustomersPage from '../../components/CustomersPage';
import Accordion from '../../components/base/Accordion';

import 'suggestions-jquery';
import 'suggestions-jquery/dist/css/suggestions.min.css';

import './styles.css';

$(() => {
    Header.create();
    Footer.create();
    CustomersPage.create();
    initAccordion();
    initCitySuggestions();
    initCustomersInputField();
    initDeliveryCalculator();
});

function initAccordion() {
    Accordion.create();

    /** берём дата атрибут из соответствующего списка часто задаваемых вопросов
     * кликаем соответствующий таю аккордеона, и стираем этот атрибут из localStorage
     */
    if (localStorage.getItem('toOpenAccordionTab') !== null) {
        setTimeout(() => {
            $(`#${JSON.parse(localStorage.getItem('toOpenAccordionTab'))}`).click();
            localStorage.removeItem('toOpenAccordionTab');
        }, 50);
    }
}

function initCitySuggestions() {
    $('#suggest-city').suggestions({
        token: '894dab0fe7381be927bc66430a4ebf0f62335a8b',
        type: 'ADDRESS',
        bounds: 'city-settlement',
        addon: 'none',
        onSelect(suggestion) {
            $('input[name=fias_id]').val(suggestion.data.fias_id);
        },
    });
}

function initCustomersInputField() {
    $('.customers__field .field__input').on('input', function() {
        if ($(this).val()) {
            $(this).addClass('filled');
        } else {
            $(this).removeClass('filled');
        }
    });
}

function initDeliveryCalculator() {
    $('[data-delivery-calc-btn]').click(function() {
        var $deliveryPrice = $('[data-delivery-price]');
        var $btn = $(this);
        var fiasId = $('input[name=fias_id]').val();
        if (!fiasId) return;

        $btn.prop('disabled', true);
        $deliveryPrice.parent().hide();
        $.post(
            '/api/internal/basket/calcDelivery/courier_delivery/',
            {
                fiasId,
                noBasket: true,
            },
            function(result) {
                $btn.prop('disabled', false);
                $deliveryPrice
                    .html(`${result.price}&nbsp;₽`)
                    .parent()
                    .show();
            }
        );
    });
}
